var React = require('react');

function IconPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.998 10L4.736 6l5.262-4v8zM2.631 9.5v-7","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconPrev.defaultProps = {"width":"13","height":"12","fill":"none"};

module.exports = IconPrev;

IconPrev.default = IconPrev;
